<template>
	<div class="bg-gradient splash-layout pad-x">
		<div class="splash-content">
			<Logo no-link />
			<router-view />	
		</div>
	</div>
</template>

<script>
import layout from '@/mixins/layout';

export default {
	name: 'SplashLayout',
	mixins: [layout],
	computed: {
		rootClass() {
			return 'splash';
		},
	},
};
</script>

<style>
.splash-layout {
	min-width: 100vw;
	min-height: 100vh;
}

.splash-content {
	padding-top: 16vh;
	max-width: 100%;
	width: 575px;
	flex: 0 1 575px;
	margin: 0 auto;
}

.splash-content .logo {
	width: 300px;
	max-width: 100%;
	margin: 0 auto 40px;
}

.splash-content .field-label {
	font-weight: 700;
	font-size: 16px;
	line-height: 18px;
	color: #140047;
}
</style>